import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faTimes } from "@fortawesome/free-solid-svg-icons";
import Button from "../../../../shared/button/Button";
import {
  ButtonsWrapper,
  ActionConfirmation,
  CloseButton,
  ActionConfimationIcon,
  ActionConfirmationMessage,
  Divider,
  DeclineButton,
} from "../styles/action-confirmation-styles";

const displayNameMap = {
  "phone-interview": "Phone",
  "first-interview": "First",
  "second-interview": "Second",
};

const RejectActionConfirmation = ({
  handleActionConfirmation,
  handleCancelRecruiterConfirmation,
  interviewType,
}) => (
  <ActionConfirmation>
    <CloseButton onClick={(e) => handleCancelRecruiterConfirmation(e)}>
      <FontAwesomeIcon icon={faTimes} />
    </CloseButton>
    <ActionConfimationIcon className="animated bounceIn delay-2">
      <FontAwesomeIcon icon={faArrowCircleRight} />
    </ActionConfimationIcon>
    <ActionConfirmationMessage className="animated fadeInUp delay-3">
      What do you want to do?{" "}
    </ActionConfirmationMessage>
    <ButtonsWrapper>
      <Button
        primary
        buttonName={`Confirm ${displayNameMap[interviewType]} Interview`}
        onClickAction={() => handleActionConfirmation("confirm")}
        classes="animated fadeInUp delay-4"
      />
      <Divider className="animated fadeInUp delay-5">or</Divider>
      <DeclineButton
        onClick={() => handleActionConfirmation("decline")}
        className="animated fadeInUp delay-5"
      >
        Withdraw Candidate
      </DeclineButton>
    </ButtonsWrapper>
  </ActionConfirmation>
);

RejectActionConfirmation.propTypes = {
  handleActionConfirmation: PropTypes.func.isRequired,
  handleCancelRecruiterConfirmation: PropTypes.func.isRequired,
  interviewType: PropTypes.string.isRequired,
};

export default RejectActionConfirmation;
